<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
  
========================================================================================== -->


<template>
    <div class="mt-5 flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center mt-5">
            <vx-card class="mt-5">
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Reset Password</h4>
                                    <p>Please enter your new password.</p>
                                </div>
                                 <vs-input disabled type="email" label-placeholder="Your Email" v-model="accountEmail" class="w-full mb-6" />
                                <vs-input type="password" label-placeholder="Current Password" v-model="currentPass" class="w-full mb-6" />

                                <vs-input type="password" label-placeholder=" New Password" v-model="value1" class="w-full mb-6" />
                                <vs-input type="password" label-placeholder="Confirm New Password" v-model="value2" class="w-full mb-8" />

                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                   <!-- <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go Back To Login</vs-button>
                                   --> <vs-button class="w-full sm:w-auto" @click= "reset">Change Password</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import * as firebase from 'firebase/app'
import "firebase/auth"

export default {
    data() {
        return {
            value1: '',
            value2: '',
            currentPass:"",
            actionCode:"",
            accountEmail:""
        }
    },
    methods:{
        reset(){
                let user = firebase.auth().currentUser
                var credential = firebase.auth.EmailAuthProvider.credential(
                user.email, // references the user's email address
                this.currentPass
            )
                            const thisIns = this

         user.reauthenticateWithCredential(credential).then(()=>{

            if(this.value1===this.value2){
                
               // console.log(code)

                    user.updatePassword(thisIns.value1).then(function() {
            

               thisIns.notifysuccess();
                  setTimeout( () => thisIns.$router.push({ path: '/'}), 4000);

                }).catch(function(error) {
                    console.log(error)
                    thisIns.$vs.notify({
                title: 'Reset Password',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
                time:2000
            });
                })
            
                    
                    
            }
            else {
                var error = "Password does not match"
                this.notify(error)
            }
            }).catch(error=>{
                    thisIns.notify(error.message)
            })
        },
        notifysuccess() {
             this.$vs.notify({color:'success',title:'Password Reset Successfully',text:'You have updated your password Successfully', time:3000})
        },
        notify(message){
            this.$vs.notify({
                title: 'Reset Password',
                text: message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
                time:2000
            });
        },

    },
    created(){
        
    let user = firebase.auth().currentUser
    this.accountEmail= user.email
    //console.log(this.accountEmail)

}
}
</script>
